const apiConfig = {
    "baseUrl":" http://localhost:8080",
    "gatWayUrl":"https://login-api.tiburaglobal.com:8082",
    "dashboard":"http://localhost:8082/",
    "webUrl":"https://synergy-uat.axodesk.com/login",
    "appName": "Identti Front End",
    "apiKey": "apiKey",
    "appId": "6852fe2f2201d00099b78c4b",
    "secrect": "secrect"
}
export default apiConfig;


